<router-outlet></router-outlet>

<ng-container *ngIf="!editingChecklist">
  <ng-container *ngIf="this.checklistService.projectInfo.checklists[0]?.displayMethod">
    <app-project-info-checklist-form></app-project-info-checklist-form>
  </ng-container>
  
  <div class="template-button-container">
    <div class="width-container wrapped-button-container fatbuttongroup">
      <button
        mat-button
        class="wrapped-button button-width btn-green"
        type="button"
        [disabled]="checklistService.projectInfo.checklists.length === 0 || !checklistService.projectInfo.checklists[0]?.displayMethod"
        (click)="saveTemplate()"
        anessaTranslation="PROJECT.PROJECT_INFO.CHECKLIST.TEMPLATE.SAVE_TEMPLATE">
      </button>
      <button
        mat-button
        class="wrapped-button button-width btn-red"
        type="button"
        (click)="cancelTemplate()"
        anessaTranslation="PROJECT.COMMON.CANCEL">
      </button>
    </div>
  </div>
</ng-container>